import React, { PureComponent } from 'react';
import { MdOutlineMyLocation } from 'react-icons/md';

import MapButton from './MapButton';

interface CoordinateDisplayButtonProps {
  onClick: () => void;
  toggled: boolean;
}

export default class CoordinateDisplayButton extends PureComponent<CoordinateDisplayButtonProps> {
  render() {
    return (
      <MapButton tooltip="Show coordinates" onClick={this.props.onClick} toggled={this.props.toggled}>
        <MdOutlineMyLocation size={22} />
      </MapButton>
    );
  }
}
